module.exports = __webpack_public_path__ + "txtperso.a865a8b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/txtperso.png
// module id = VGYv
// module chunks = 0